import ProfessionCard from './ProfessionCard.vue';

export default ProfessionCard;



// WEBPACK FOOTER //
// ./src/pages/professions/card/index.ts